import { ModalFilter } from "./interface";

const DEFAUT_VALUEE_FILTERS: ModalFilter = {
	companyIds: [],
	taxiServiceIds: [],
	types: [],
};

// eslint-disable-next-line import/prefer-default-export
export { DEFAUT_VALUEE_FILTERS };
